import {Rental} from "@olivades/pattern-lib";
import {studio1} from "./studio1";
import {studio2} from "./studio2";
import {studio3} from "./studio3";
import {studio4} from "./studio4";
import {studio5} from "./studio5";
import {studio6} from "./studio6";
import {apt1} from "./apt1";
import {apt2} from "./apt2";
import {chambre1} from "./room1";
import {chambre2} from "./room2";

export const AllLocations: TranslatableRental[] = [studio1, studio2, studio3, studio4, studio5, studio6, apt1, apt2, chambre1, chambre2]

export type TranslatableRental = Omit<Rental, 'name' | 'description'> & {
  name: { fr: string; en: string };
  description: { fr: string; en: string };
}
